// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"b9bbcc22","239":"87fe8e77","455":"5934a325","857":"bc4126cf","963":"55d6db3c","977":"89ab62e5"}[chunkId] + ".chunk.js";
};